<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import PortfolioNavigation from './PortfolioNavigation.vue';
    import DecisionNavigation from './DecisionNavigation.vue';

    @Component({
        props: {
            workspaceId: {
                type: Number,
                required: true
            },
            projectId: {
                type: Number,
                required: true
            }
        },
        components: {
            PortfolioNavigation,
            DecisionNavigation
        }
    })
    export default class PortfolioOrDecisionNavigation extends Vue
    {
        // Detect type from URL path (assuming hash mode)
        get solutionType(): string
        {
            const path = this.$route.path.toLowerCase();
            if (path.startsWith('/portfolio')) return 'portfolio';
            if (path.startsWith('/decision')) return 'decision';
            return 'portfolio'; // default/fallback
        }

        get navComponent(): any
        {
            return this.solutionType === 'portfolio'
                ? 'PortfolioNavigation'
                : 'DecisionNavigation';
        }
    }
</script>

<template>
    <component :is="navComponent"
               :workspaceId="workspaceId"
               :projectId="projectId" />
</template>
